/**
 * pv-variant-sync.js — il segnale del cambio formato.
 *
 * PERCHE' ESISTE
 * In questa versione di Horizon il cambio di variante NON emette l'evento
 * `variant:update`: verificato in anteprima il 29/08/2026, il componente
 * <variant-picker> emette solo `shopify:product:select` sull'elemento e poi
 * aggiorna il prezzo per conto suo. Per questo il blocco Klarna della scheda
 * (che ascolta `variant:update`) sul sito pubblicato non si aggiorna mai:
 * scegli il 50x70 e continua a dire «3 rate da 5,00 €».
 *
 * COSA FA
 * Ascolta in delega il `change` degli input del selettore formato e rilancia
 * su `document` un evento `variant:update` con la forma che i blocchi si
 * aspettano: detail.resource = { id, price }. Cosi' la riga «prendine due»,
 * le tre promesse, il bundle e Klarna si aggiornano tutti con lo stesso
 * segnale, senza dipendere dagli interni di Horizon.
 *
 * Se un domani Horizon iniziasse a emettere `variant:update` da solo, i
 * blocchi riceverebbero due eventi identici e si ridipingerebbero due volte:
 * innocuo.
 */
(function () {
  if (window.__pvVariantSync) return;
  window.__pvVariantSync = true;

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.dataset || !input.dataset.variantId) return;
    if (!input.closest('.pv-fmt')) return;

    var id = Number(input.dataset.variantId);
    if (!id) return;
    var price = input.dataset.price ? Number(input.dataset.price) : undefined;

    document.dispatchEvent(
      new CustomEvent('variant:update', {
        bubbles: true,
        detail: { resource: { id: id, price: price }, sourceId: 'pv-variant-sync' }
      })
    );
  });
})();
